<template>
  <!-- Navbar -->
  <nav
    class="
      absolute
      left-0
      top-0
      z-50
      flex
      w-full
      items-center
      bg-transparent
      p-4
      md:flex-row
      md:flex-nowrap
      md:justify-start
    "
  >
    <div class="mx-auto flex w-full flex-wrap items-center justify-between px-4 md:flex-nowrap md:px-10">
      <!-- Brand -->
      <a-breadcrumb class="hidden text-sm font-semibold lg:inline-block">
        <a-breadcrumb-item>
          <router-link
            to="/app/dashboard"
            class="hidden text-sm font-semibold lg:inline-block"
            aria-label="Dashboard"
          >
            <i class="fa-solid fa-house" />
          </router-link>
        </a-breadcrumb-item>
        <template
          v-for="(route, index) in $route.matched"
          :key="index"
        >
          <a-breadcrumb-item v-if="route.name">
            <!-- Only show router-link for parent routes -->
            <router-link
              v-if="index < $route.matched.length - 1 && $route.matched.length - 1 != index"
              :to="route.path"
            >
              {{ route.name }}
            </router-link>
            <!-- Display text for the current route -->
            <span v-else>
              {{ route.name }}
            </span>
          </a-breadcrumb-item>
        </template>
      </a-breadcrumb>
      <form
        class="mr-3 hidden flex-row flex-wrap items-center md:flex lg:ml-auto"
        @submit.prevent="goToResultsPage"
      >
        <div class="relative flex w-full flex-wrap items-stretch">
          <a-config-provider
            :theme="{
              token: {
                colorBgContainer: darkMode ? '#1F1F1F' : '#FFFFFF',
              }
            }"
          >
            <a-input
              v-model:value="query"
              size="large"
              placeholder="Search here..."
            >
              <template #suffix>
                <i
                  class="fa-solid fa-magnifying-glass cursor-pointer opacity-50"
                  @click="goToResultsPage"
                />
              </template>
            </a-input>
          </a-config-provider>
        </div>
      </form>
      <!-- User -->
      <ul class="m-0 hidden list-none flex-col items-center md:flex md:flex-row">
        <user-dropdown />
      </ul>
    </div>
  </nav>
  <!-- End Navbar -->
</template>

<script setup lang="ts">
import UserDropdown from '../Dropdowns/UserDropdown.vue';
import { useStore } from '../../api/index.ts';
import { useRouter } from 'vue-router';
import { ref, computed } from 'vue';

const store = useStore();
const router = useRouter();

const query = ref('');

const darkMode = computed(() => {
  return store.userPreferences.darkMode;
});

function goToResultsPage() {
  router.push({ path: '/app/search', query: { query: query.value } });
}
</script>
